/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TopBar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Age from './Age/index'
import AgeGenderSeparator from './AgeGenderSeparator/index'
import CustomResource from './CustomResource/index'
import DateOfBirth from './DateOfBirth/index'
import Gender from './Gender/index'
import GenderBirthSeparator from './GenderBirthSeparator/index'
import HumanId from './HumanId/index'
import Name from './Name/index'
import Order from './Order/index'
import Profile from './Profile/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaIconLocationOnFilled from 'DesignSystem/Svgs/TysiaIconLocationOnFilled/index'
import TysiaIconPersonFilled from 'DesignSystem/Svgs/TysiaIconPersonFilled/index'
import TysiaIconTag from 'DesignSystem/Svgs/TysiaIconTag/index'
import styles from './view.module.css'
let AssignedAssistants = React.lazy(() => import('./AssignedAssistants/index'))
let AssignedProviders = React.lazy(() => import('./AssignedProviders/index'))
let ExternalProfessionals = React.lazy(() => import('./ExternalProfessionals/index'))
let Locations = React.lazy(() => import('./Locations/index'))
let OtherRelatives = React.lazy(() => import('./OtherRelatives/index'))
let ResponsibleParties = React.lazy(() => import('./ResponsibleParties/index'))
let School = React.lazy(() => import('./School/index'))
let UpcomingAppointments = React.lazy(() => import('./UpcomingAppointments/index'))



/** @type {import('Simple/types.js').View} */
export default function TopBar({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="TopBar.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z26QA0q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-2-Z26QA0q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Z26QA0q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TopBar.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
</div>
<div
  data-testid="TopBar.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="TopBar.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-4-Z26QA0q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<CustomResource
  viewPath={`${viewPath}/CustomResource`}
/>
<Order
  viewPath={`${viewPath}/Order`}
/>
</div>
<div
  data-testid="TopBar.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaIconPersonFilled
  viewPath={`${viewPath}/TysiaIconPersonFilled`}
 width={16}
 height={16}
 fill={dtColorsNeutral400}
 marginRight={4}
/>
<Age
  viewPath={`${viewPath}/Age`}
/>
<AgeGenderSeparator
  viewPath={`${viewPath}/AgeGenderSeparator`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<GenderBirthSeparator
  viewPath={`${viewPath}/GenderBirthSeparator`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
</div>
<div
  data-testid="TopBar.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaIconLocationOnFilled
  viewPath={`${viewPath}/TysiaIconLocationOnFilled`}
 width={16}
 height={16}
 fill={dtColorsNeutral400}
 marginRight={4}
/>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Locations
{...childProps}
  viewPath={`${viewPath}/Locations`}
/>
)}
</SuspenseBoundary>
</div>
<div
  data-testid="TopBar.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaIconTag
  viewPath={`${viewPath}/TysiaIconTag`}
 width={16}
 height={16}
 fill={dtColorsNeutral400}
 marginRight={4}
/>
<HumanId
  viewPath={`${viewPath}/HumanId`}
/>
</div>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="TopBar.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<AssignedProviders
  viewPath={`${viewPath}/AssignedProviders`}
/>
<AssignedAssistants
  viewPath={`${viewPath}/AssignedAssistants`}
/>
<ExternalProfessionals
  viewPath={`${viewPath}/ExternalProfessionals`}
/>
<School
  viewPath={`${viewPath}/School`}
/>
</div>
)}
</SuspenseBoundary>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="TopBar.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<ResponsibleParties
  viewPath={`${viewPath}/ResponsibleParties`}
/>
<OtherRelatives
  viewPath={`${viewPath}/OtherRelatives`}
/>
</div>
)}
</SuspenseBoundary>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="TopBar.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<UpcomingAppointments
  viewPath={`${viewPath}/UpcomingAppointments`}
/>
</div>
)}
</SuspenseBoundary>
</div>
{children}
</React.Fragment>)
}